import { Avatar } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {Link } from 'react-router-dom';

import { ROLES } from '../../config';
import { formatDateJJMMYYYY } from '../dateFormatter';
import { getNomPrenomClearFromPersoData } from '../utils';
function Contact(props){
    Contact.propTypes = {
        role: PropTypes.any,
        id: PropTypes.any,
        username: PropTypes.any,
        time: PropTypes.any,
        lastMsg: PropTypes.any,
        to: PropTypes.any,
    };
    const role = props?.to?.role;
    // const hashedPassword = responseData?.user.password;
    let UserRoleProperty ;
    if(role === ROLES.Expert) UserRoleProperty = 'expertId';
    if(role === ROLES.Client) UserRoleProperty = 'collaboratorId';
    if(role === ROLES.Admin) UserRoleProperty = 'backOfficeId';

    return(
        <Link to={`/${props?.role}/conversation/`+props?.id}>
            <div className="chat_list active_chat">
                <div className="chat_people">
                    {/* {JSON.stringify(props?.to)} */}
                    <div className="chat_img">
                        <Avatar
                            alt="Remy Sharp"
                            src={props?.to?.[UserRoleProperty]?.persoData?.photo ?? 'https://ptetutorials.com/images/user-profile.png'}
                        />
                        {/* <img
                            src={props?.to?.[UserRoleProperty]?.persoData?.photo ?? 'https://ptetutorials.com/images/user-profile.png'}
                            alt="sunil"
                        /> */}
                    </div>
                    <div className="chat_ib">
                        <h5>{getNomPrenomClearFromPersoData(props?.to?.[UserRoleProperty]?.persoData)} <span className="chat_date">{formatDateJJMMYYYY(props?.time)}
                        </span></h5>
                        <p>{props?.lastMsg}</p>
                    </div>
                </div>
            </div>
        </Link>
    );
}

export default Contact;